
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTempHotcold as ObiTempHotcoldElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-temp-hotcold.js';
 
 
 

 
 export const ObiTempHotcold = createComponent({
   react: React,
   tagName: 'obi-temp-hotcold',
   elementClass: ObiTempHotcoldElement,
   events: {
     
   }
  });
 
 